import React from "react";
import DataMappingMultiSelect from "./DataMappingMultiSelect";
import DataMappingSingleSelect from "./DataMappingSingleSelect";

/**
 * DataMappingDropdownGroup Component
 *
 * Renders a section group with multiple dropdowns based on configuration.
 * Each section can contain multiple children dropdowns.
 * Dynamically renders multi-select or single-select based on isMulti attribute.
 */
const DataMappingDropdownGroup = ({
  section,
  safeSelections,
  updateSelections,
  loadOptions,
  stableSharedTableData,
  // Locks every dropdown in the section regardless of the table options, e.g.
  // while an auto-mapping job is running and about to replace the selections.
  disableDropdowns = false,
}) => {
  return (
    <div className="section-group">
      <h3 className="section-title">{section.sectionTitle}</h3>

      <div className="section-content">
        {section.childrens.map(child => {
          // Determine which dropdown component to render based on isMulti attribute
          const isMulti = child.isMulti !== undefined ? child.isMulti : true; // Default to true for backward compatibility

          const DropdownComponent = isMulti
            ? DataMappingMultiSelect
            : DataMappingSingleSelect;

          return (
            <div key={child.key} className="dropdown-group">
              <label className="dropdown-label">{child.label}</label>
              <DropdownComponent
                key={`${child.key}-${stableSharedTableData.isDataReady}-${stableSharedTableData.tableOptionsLength}`}
                loadOptions={loadOptions}
                selectedValues={safeSelections[child.key] || []}
                onChange={values => updateSelections(child.key, values)}
                placeholder={child.placeholder}
                isDisabled={
                  disableDropdowns ||
                  !stableSharedTableData.tableOptions ||
                  stableSharedTableData.tableOptionsLength === 0
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DataMappingDropdownGroup;
